window.onload = function() {
  const galleryElement = document.querySelector('.gallery > .swiper');
  if (galleryElement) {
    const galleryImages = new Swiper(galleryElement, {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      centeredSlides: true,
      centeredSlidesBounds: true,
      pagination: {
        el: '.gallery__slider-pagination',
        clickable: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        993: {
          slidesPerView: 4
        },
        768: {
          slidesPerView: 3,
          freeMode: false
        },
        320: {
          freeMode: true,
          loop: false,
        }
      }
    });
  } else {
    console.warn('Elemento .gallery > .swiper não encontrado.');
  }

  const collectionsElement = document.querySelector('.collections-gallery .swiper');
  if (collectionsElement) {
    const galleryCollections = new Swiper(collectionsElement, {
      slidesPerView: 2,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.featured-products__slider-pagination',
        clickable: true
      },
      breakpoints: {
        993: {
          slidesPerView: 4
        },
        768: {
          slidesPerView: 3,
          freeMode: false
        },
        320: {
          slidesPerView: 2,
          freeMode: true,
          loop: false,
        }
      }
    });
  } else {
    console.warn('Elemento .collections-gallery .swiper não encontrado.');
  }

  // ========================================
  // CARROSSEL COM SWIPE PARA MOBILE
  // ========================================

  // Função para remover texto "2x de preço" dos cards e página do produto
  function removeInstallmentText() {
    // Remover de cards de produtos
    const productCards = document.querySelectorAll('.product-card, .featured-product, .collection-product');
    productCards.forEach(card => {
      const installmentElements = card.querySelectorAll('[class*="installment"], [class*="payment"], [class*="price"]');
      installmentElements.forEach(element => {
        if (element.textContent.includes('2x de') || element.textContent.includes('2x')) {
          element.style.display = 'none';
        }
      });
    });
    
    // Remover da página do produto
    const productPage = document.querySelector('.template-product, .product-template');
    if (productPage) {
      const installmentElements = productPage.querySelectorAll('[class*="installment"], [class*="payment"], [class*="price"]');
      installmentElements.forEach(element => {
        if (element.textContent.includes('2x de') || element.textContent.includes('2x')) {
          element.style.display = 'none';
        }
      });
    }
    
    // Remover de elementos específicos com texto de parcelamento
    const allElements = document.querySelectorAll('*');
    allElements.forEach(element => {
      if (element.children.length === 0 && element.textContent.includes('2x de')) {
        element.style.display = 'none';
      }
    });
  }
  
  // Executar remoção do texto de parcelamento
  removeInstallmentText();
  
  // Observar mudanças no DOM para remover texto de parcelamento dinamicamente
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Elemento DOM
            if (node.textContent && node.textContent.includes('2x de')) {
              node.style.display = 'none';
            }
            // Verificar elementos filhos
            const installmentElements = node.querySelectorAll ? node.querySelectorAll('*') : [];
            installmentElements.forEach(element => {
              if (element.textContent && element.textContent.includes('2x de')) {
                element.style.display = 'none';
              }
            });
          }
        });
      }
    });
  });
  
  // Iniciar observação
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};


// Aplicando cupom inserido no minicart
var manageCoupon = {
	getCookie: function(name) {
	    var cookies = document.cookie;
	    var parts = cookies.split(name + "=");
	    var cookieValue = '';
	    if (parts.length == 2) {
	        cookieValue = parts.pop().split(";").shift();
	    }
	    
	    return cookieValue;
	},
	
	setCookie: function(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		let expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	},

	applyCoupon: async function(coupon){
		if(this.getCookie('discount_code') === coupon) return;
		let response = {status: null};
		
		let request = await $.get(location.origin+"/discount/"+coupon, function(data) {
		  response.status = true;
		}).fail(() => {
			response.status = false;
		});
		
		this.setCookie('discount_code', coupon, 7);
			
		if(response.status){
			location.reload();
		}
	},
	
	init: function(){
		const fieldCoupomCart = document.querySelector("#CartDrawer #addCoupoun");
		
		if(fieldCoupomCart != null){
			if(this.getCookie('discount_code')){
				fieldCoupomCart.querySelector("form input").value = this.getCookie('discount_code');
			}
			
			fieldCoupomCart.querySelector("form").addEventListener("submit", (e) => {
				e.preventDefault();
				
				const coupon = fieldCoupomCart.querySelector("form input").value;
								
				if(coupon != ""){
					this.applyCoupon(coupon);
				}
			})
			
		}
	}
}

$(document).ready(function () {
  manageCoupon.init();
});

// ========================================
// CUSTOM 4 CARDS MOBILE - MODERN ES6+ IMPLEMENTATION
// ========================================

// Load the modern custom 4 cards mobile functionality
if (typeof Custom4CardsMobile !== 'undefined') {
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new Custom4CardsMobile();
    });
  } else {
    new Custom4CardsMobile();
  }
} else {
  // Fallback: Load the script dynamically if not already loaded
  const script = document.createElement('script');
  script.src = '/assets/custom-4-cards-mobile.js';
  script.onload = () => {
    if (typeof Custom4CardsMobile !== 'undefined') {
      new Custom4CardsMobile();
    }
  };
  document.head.appendChild(script);
}

class Theme{
	init(){
		const closeBtn = document.querySelector('#close-minicart');
		
		if(closeBtn){
			closeBtn.addEventListener("click", (e) => {
				e.preventDefault();
				document.querySelector('.window-overlay').click();
			});
		}
	}
}


const theme = new Theme();
theme.init();



window.addEventListener("load", () => {
  (function() {
      'use strict';
      var oldXHR, stateChangeHandler, prop;
    
      oldXHR = window.XMLHttpRequest;
    
      stateChangeHandler = function (evt) {
        switch (this.readyState) {
          case oldXHR.OPENED:
            //console.log('Request was made', this, evt);
            break;
          case oldXHR.DONE:
              //console.log('Request was finished', this);
              if(this.responseURL.indexOf('/cart/shipping_rates.json?') != -1)
            	theme.init();
            break;
        }
      };
    
      function newXHR() {
        var xhr = new oldXHR();
        xhr.addEventListener('readystatechange', stateChangeHandler);
        return xhr;
      }
    
      // Copy original states and toString
      for (prop in oldXHR)
        newXHR[prop] = oldXHR[prop];
      
      window.XMLHttpRequest = newXHR;
    })();
});


window.addEventListener('load', function() {
    document.querySelectorAll('.header-menu .header-menu__list.header-menu__list--main .header-menu__item-text').forEach((item) => {
        if(item.textContent.trim().toLowerCase() === 'sale') {
            item.classList.add('menu-sale');
        }
    });
});

const ProductPage = {
    init: function() {
        this.checkIfMobile();
    },

    checkIfMobile: function() {
        if (window.innerWidth < 1199) {
            // this.moveBreadcrumb(); // Removido para manter breadcrumb na posição original
            this.moveProductFormMobile();
        }
    },

    // moveBreadcrumb: function() {
    //     const templateProductPage = document.querySelector('.template-product');
    //     if (templateProductPage !== null) {
    //         const breadcrumb = document.querySelector('nav.breadcrumb');
    //         const productForm = document.querySelector('form.product-form');

    //         if (breadcrumb && productForm) {
    //             productForm.insertAdjacentElement('afterbegin', breadcrumb);
    //         }
    //     }
    // },

    moveProductFormMobile: function() {
        const productFormMobile = document.querySelector('.js-product-form-mobile');
        const breadcrumb = document.querySelector('nav.breadcrumb');

        if (productFormMobile && breadcrumb) {
            breadcrumb.insertAdjacentElement('afterend', productFormMobile);
        }
    }
};

window.addEventListener('load', function() {
    ProductPage.init();
    recomendedCustomSwatches()
});


const searchMobileIcon = document.querySelector('.header__icon--search-mobile');
if (searchMobileIcon) {
    searchMobileIcon.addEventListener('click', function() {
        const lupaIcon = document.querySelector('.header__icon--lupa');
        const closeIcon = document.querySelector('.header__icon--close');
        const searchMobile = document.querySelector('.search__mobile');

        // Toggle the display of icons
        if (lupaIcon && closeIcon) {
            if (lupaIcon.style.display !== 'none') {
                lupaIcon.style.display = 'none';
                closeIcon.style.display = 'block';
            } else {
                lupaIcon.style.display = 'block';
                closeIcon.style.display = 'none';
            }
        }

        // Toggle the 'show' class on .search__mobile
        if (searchMobile) {
            searchMobile.classList.toggle('show');
        }
    });
}

function productCardCustomSwatches(){
	let swatchesWrapper = document.querySelectorAll('.product-card__swatches-wrapper');

	
	swatchesWrapper.forEach((item) => {
		let swatchesParent = item
		let hex = item.querySelectorAll('.product-card_custom-hex span');
		hex.forEach((item)=>{
			let h = item.dataset.hex;
			let colorName = item.dataset.value.split('/');
			
			let dataSwatch = swatchesParent.querySelectorAll('[data-swatch]');
			dataSwatch.forEach((sku) => {
				let newName = colorName[0].replace(/(\r\n|\n|\r)/gm, "");
				// Só aplica o hex se existir e se não há uma regra CSS específica para a cor
				if(newName.includes(sku.dataset.swatch) && h && h.trim() !== ''){
					// Verifica se já existe uma regra CSS específica para esta cor
					const colorLower = sku.dataset.swatch.toLowerCase();
					const hasCustomCSS = colorLower.includes('verde musgo') || 
										 colorLower.includes('bege') || 
										 colorLower.includes('azul claro') || 
										 colorLower.includes('caramelo') || 
										 colorLower.includes('cinza');
					
					// Só aplica o hex se não houver regra CSS específica
					if (!hasCustomCSS) {
						sku.style=`--swatch-color:${h}`
					}
				}
			})
		})
	})
	
}


function recomendedCustomSwatches(){
	// Selecionar o elemento que precisa ser observado
	const targetSelector = '.product-recommendations.is-loading';
	if(document.querySelector(targetSelector)){
		function elementoCarregado() {
		    productCardCustomSwatches();
		}
		
		const intervalId = setInterval(() => {
		    const elemento = document.querySelector(targetSelector);
		    if (!elemento) {
		        elementoCarregado();
		        clearInterval(intervalId); // Parar de verificar após encontrar o elemento
		    }
		}, 1000); // Verificar a cada 1000ms (1 segundo)
	} else {
		productCardCustomSwatches()
	}
}


function addShowClassOnVideoClick() {
    const videoElement = document.querySelector('.promotion-content__video');
    const overlayElement = document.querySelector('.promotion-content__overlay');
    const body = document.body;

    if (videoElement && overlayElement) {
        // Adicionar a classe "show" ao clicar no vídeo
        videoElement.addEventListener('click', () => {
            overlayElement.classList.add('show');
            body.style.overflow = 'hidden'; // Desativa o scroll no body
        });

        // Remover a classe "show" ao clicar no overlay
        overlayElement.addEventListener('click', () => {
            overlayElement.classList.remove('show');
            body.style.overflow = ''; // Restaura o scroll no body
        });
    }
}

// Chamada da função
addShowClassOnVideoClick();



const forceHideElement = setInterval(() => {
    const modalMarkElement = document.querySelector("#appView .powrModal .powrMark");
    if (modalMarkElement) {
        modalMarkElement.style.display = "none"; // Oculta o elemento
        modalMarkElement.style.visibility = "hidden"; // Garante que não apareça
        modalMarkElement.style.opacity = "0"; // Torna invisível mesmo se visibilidade for alterada
        clearInterval(forceHideElement); // Para o intervalo
    }
}, 1000);

// Altera o text padrão do botão de pagamento na página do produto de "Compre já" para "Comprar"
function changeButtonText() {
    const paymentButton = document.querySelector('.shopify-payment-button__button');
    if (paymentButton) {
        paymentButton.textContent = "Comprar";
    }
}

changeButtonText();








